/* import __COLOCATED_TEMPLATE__ from './sms.hbs'; */
import TwoFactorEnrollSmsComponent from '@square/ember-multipass-components/components/ember-multipass-components/two-factor/enroll/sms';
export default class TwoFactorMandatoryPromoSmsComponent extends TwoFactorEnrollSmsComponent {
  constructor() {
    super(...arguments);
  }
}